"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinksTrayWrap = exports.LinksTray = void 0;
const classnames_1 = __importDefault(require("classnames"));
const lodash_throttle_1 = __importDefault(require("lodash.throttle"));
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const window_or_global_1 = __importDefault(require("window-or-global"));
const shared_1 = require("../../shared");
exports.LinksTray = styled_components_1.default.div `
	visibility: ${(p) => (p.menuOpen ? "visible" : "hidden")};
	&:hover {
		visibility: visible;
	}
	position: relative;
	background: ${(p) => p.theme.palette.background.paper};
	left: ${(p) => (p.menuOpen ? 0 : "100%")};
	transition: left 0.2s ease-in-out;
	width: 100%;
	height: 100%;

	.tray-menu-item {
		width: 100%;
		cursor: pointer;
		position: static;
	}

	.enhanced-dropdown-layout {
		background: ${(p) => p.theme.palette.background.default};
		margin-left: 0;
		width: 100%;
		height: 100%;
		.describe,
		.external {
			white-space: normal;
		}
	}
`;
const Styled = styled_components_1.default.div `
	visibility: hidden;
	position: absolute;
	overflow: hidden;
	z-index: 9001;
	left: 64px;
	height: auto;
	max-height: ${(p) => (p.innerHeight ? `${p.innerHeight - p.theme.navHeight}px` : "100vh")};
	width: calc(100% - 64px);

	&.mobile {
		left: 48px;
		height: ${(p) => (p.innerHeight ? `${p.innerHeight - p.theme.navHeight}px` : "auto")};
		width: calc(100% - 48px);
	}

	&.inner-menu-open {
		overflow: initial;
	}

	&.menu-open {
		visibility: visible;
	}
`;
const LinksTrayWrap = ({ children, menuOpen, mobile, topOffset = 0 }) => {
    const { innerMobileMenu } = (0, shared_1.useInnerMobileMenu)();
    const [height, setHeight] = (0, react_1.useState)(0);
    const checkHeight = (0, react_1.useCallback)(() => {
        var _a;
        const innerHeight = window_or_global_1.default.innerHeight;
        // visualViewport doesn't have full browser support, it may be undefined
        const visualHeight = (_a = window_or_global_1.default.visualViewport) === null || _a === void 0 ? void 0 : _a.height;
        const height = (mobile ? visualHeight || innerHeight : innerHeight) - topOffset;
        setHeight(height);
    }, [setHeight, mobile, topOffset]);
    const throttleCheck = (0, lodash_throttle_1.default)(checkHeight, 250, { leading: false });
    (0, react_1.useEffect)(() => {
        checkHeight();
        window_or_global_1.default.addEventListener("resize", throttleCheck);
        return () => {
            throttleCheck.cancel();
            window_or_global_1.default.removeEventListener("resize", throttleCheck);
        };
    }, [checkHeight, throttleCheck]);
    const classes = (0, classnames_1.default)({
        ["inner-menu-open"]: innerMobileMenu,
        ["menu-open"]: menuOpen,
        mobile,
    });
    return (react_1.default.createElement(Styled, { innerHeight: height, className: classes }, children));
};
exports.LinksTrayWrap = LinksTrayWrap;
//# sourceMappingURL=LinksTray.js.map